<template>
  <div class="l-election2026">
    <a href="#accesskey-c" class="skip-to-content" title="跳至主要內容區塊" tabindex="1">跳至主要內容區塊</a>

    <!--
      活動列：刻意不使用網站主 header 與紅色分類導覽列。
      開票夜的首屏高度必須留給開票資料，見設計稿 HANDOFF 段。
    -->
    <div class="l-election2026__bar">
      <a href="/" title="回 CTWANT 首頁">
        <img
          src="https://static.ctwant.com/images/dist/logo-w.svg"
          class="l-election2026__logo"
          width="87"
          height="15"
          alt="CTWANT 識別標誌"
        >
      </a>
      <span class="l-election2026__divider" />
      <!--
        長短版文案以 CSS 切換，不依賴 isMobile ——
        isMobile 在 SSR 由 user-agent 決定、在 client 由 screenWidth 決定，
        兩者不一定一致，用它切換文字會造成 hydration 不匹配。
      -->
      <span class="l-election2026__title">
        <span class="l-election2026__title--full">2026 縣市長選舉 特別報導</span>
        <span class="l-election2026__title--short">2026 縣市長選舉</span>
      </span>
      <a href="/" class="l-election2026__home" title="回 CTWANT 首頁">
        <span class="l-election2026__home--full">回 CTWANT 首頁 ›</span>
        <span class="l-election2026__home--short">首頁 ›</span>
      </a>
    </div>

    <main>
      <a id="accesskey-c" accesskey="C" href="#accesskey-c" title="主要內容區塊" class="sr-only">:::</a>
      <nuxt />
    </main>

    <GDPR />
    <Footer id="accesskey-b" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Footer from '@/components/Footer.vue'
import GDPR from '@/components/GDPR.vue'

export default {
  components: {
    Footer,
    GDPR
  },
  computed: {
    ...mapGetters([
      'WIDTH_LAPTOP',
      'WIDTH_MOBILE',
      'screenWidth'
    ])
  },
  beforeMount() {
    // screenWidth / isLaptop / isMobile 由此賦值，卡片與地圖的 RWD 依賴這些狀態。
    this.SET_SCREEN_WIDTH(window.screen.width)
    window.addEventListener('scroll', this.scrollTopHandler)

    // 廣告：本 layout 只掛手機版蓋版廣告（容器在 Footer 的 AdPopup），
    // 刻意不呼叫 ad/registerGlobalSlots —— 活動頁沒有一般廣告版位，
    // 也避免 SPA 換頁到 default 版型時重複 defineSlot 同一個 div 而出錯。
    this.closePopupIfRendered()
    this.$store.dispatch('ad/enableServices')
  },
  mounted() {
    this.SET_IS_LAPTOP(this.screenWidth <= this.WIDTH_LAPTOP)
    this.SET_IS_MOBILE(this.screenWidth <= this.WIDTH_MOBILE)

    // 蓋版廣告與全站相同：僅手機（≤ 576px）、捲動超過頁面 3 成時出現，一次瀏覽只出現一次。
    // 選舉屬政治新聞，沒有專屬版位，使用預設的 CTWant_popup_320x480。
    // 放在 layout 而非各頁：活動三種頁面共用本 layout，只需呼叫一次
    this.$store.dispatch('ad/registerAndDisplayPopupAd')
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollTopHandler)
    // SPA 換頁到其他版型（如 Footer 的關於我們）時 Footer 會重建，同理需關閉
    this.closePopupIfRendered()
  },
  methods: {
    ...mapMutations([
      'SET_SCREEN_WIDTH',
      'SET_SCROLL_TOP',
      'SET_IS_LAPTOP',
      'SET_IS_MOBILE'
    ]),
    scrollTopHandler() {
      this.SET_SCROLL_TOP(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop)
    },
    /**
     * 本次瀏覽已顯示過蓋版廣告時，不再顯示
     *
     * 切換版型時 Footer 會重建，已渲染的廣告不會跟著過去，新的容器是空的；
     * 而 registerAndDisplayPopupAd 會因「已渲染過」而跳過，使用者捲動後就會看到空白蓋版。
     * 直接關閉，與全站「一次瀏覽只出現一次蓋版廣告」的行為一致。
     */
    closePopupIfRendered() {
      if (this.$store.state.ad.isAlreadyRenderPopupAd) {
        this.$store.commit('ad/SET_IS_POPUP_ACTIVE', false)
      }
    }
  }
}
</script>

<style lang="scss">
@import 'notyf/notyf.min.css';
@import '../assets/scss/main.scss';
@import '../assets/scss/layout/_election2026.scss';
// 頁面樣式在此統一引入，讓主頁與縣市頁共用同一份 CSS，
// 且元件（CountyCard / SeatBar）的樣式不受 scoped 限制影響
@import '../assets/scss/pages/_election2026.scss';

.skip-to-content {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  color: $primary;
  font-size: 1.2rem;
  z-index: 100001;

  &:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
    margin: 0;
    padding: 1.7rem 2rem 1.2rem;
    border: 1px solid #dedede;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
